<template>
    <!--<div style="width:100%;text-align: center;">
    <v-container justify="center" fill-height fluid style="margin:20px;padding:0px;width:100%;text-align: center;">-->
    <v-container class="content-background" fluid style="background-color: #ffffff;">

    <!--<AgGridCustom />-->

        <div v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">

          <div style="min-width:100%;width:100%;" class="d-flex align-center flex-column">
                    <div style="width:100%;text-align:left;text-decoration: none;">
                    </div>

            <span style="width:100%;">

                <NavBar_Variant></NavBar_Variant>

                <v-container justify="center" fill-height fluid>
                    <v-row>
                        <div style="width:100%;" v-html="this.$store.getters.getProcessState('load-results')"></div>
                    </v-row>
                   <v-row style="text-align: center;margin-bottom:0;padding-bottom:0;">
                        <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">

                             <!-- General Gene Information -->
                                  <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                             <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Gene
                                             </v-toolbar-title>
                                        </v-toolbar>
                                  </div>
                                  <v-card class="elevation-1 content-box"  style="padding-left:10px;padding-right:10px;">
                                     <div class="content-box-header-space"></div>

                                        <v-table style="text-align:left;padding:10px;width:100%;">
                                                    <div v-if="'gencode_genomic' in item">
                                                    <div v-if="'gene' in item['gencode_genomic']">
                                                        <div v-for="gene in item['gencode_genomic']['gene']">
                                                            <tr><td style="min-width:200px;">HGNC gene symbol</td><td>{{ item["UTA_Adapter"]["gene_name"] }}</td></tr>
                                                            <tr><td>Ensembl gene ID</td><td>{{ item["dbnsfp"]["Ensembl_geneid_formatted"] }}</td></tr>
                                                            <tr>
                                                                <td>Entrez Gene ID</td>
                                                                <td>
                                                                    <span v-if="'oncokb' in item">
                                                                        <span v-if="'oncokb' in item['oncokb']">
                                                                            <span v-if="'exact_match' in item['oncokb']['oncokb']">
                                                                                <span v-if="'query' in item['oncokb']['oncokb']['exact_match']">
                                                                                    {{ item["oncokb"]["oncokb"]["exact_match"]["query"]["entrezGeneId"] }}
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="'alphamissense' in item">
                                                                <td>Uniprot ID</td>
                                                                <td>
                                                                    <span v-if="'alphamissense' in item">
                                                                        <span v-if="'uniprot_id' in item['alphamissense']">
                                                                                    {{ item["alphamissense"]["uniprot_id"] }}
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr><td>Chromosome</td><td>{{ item["variant_data"]["CHROM"] }}</td></tr>
                                                            <tr><td>Start-End <br/>(GRCh38) </td><td>{{ gene[' start_pos'] }} - {{ gene[' end_pos'] }}</td></tr>
                                                            <tr><td>Strand</td><td>{{ gene[' strand'] }}</td></tr>
                                                        </div>
                                                    </div>
                                                    </div>
                                        </v-table>

                                        <div v-if="'UTA_Adapter' in item" style="padding:10px;">
                                             <div>
                                                <a v-bind:href="this.$store.getters.getRouterBaseURL + '/show-gene-details/' + item.UTA_Adapter.gene_name">
                                                    Show gene entry (Onkopus)
                                                </a>
                                             </div>
                                             <div>
                                                 <a style=""
                                                    v-bind:href="'https://www.genecards.org/cgi-bin/carddisp.pl?gene='+item.UTA_Adapter.gene_name">
                                                    Show GeneCards entry ({{ item.UTA_Adapter.gene_name }})
                                                 </a>
                                             </div>
                                        </div>

                                  </v-card>
                                  <div style="height:0px;"></div>
                                  <div v-if="'UTA_Adapter' in item">
                                      <div class="content-box-toolbar-div">
                                            <v-toolbar class="rounded-lg elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                                 <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                       Variant
                                                 </v-toolbar-title>
                                            </v-toolbar>
                                      </div>
                                      <v-card class="elevation-1 content-box"  style="padding-left:10px;padding-right:10px;">
                                         <div class="content-box-header-space"></div>
                                         <v-table v-if="'UTA_Adapter' in item" style="text-align:left;padding:10px;width:100%;">
                                            <tr><td>HGVS</td><td>{{ k }}</td></tr>
                                            <tr v-if="'UTA_Adapter' in item">
                                                <td>
                                                    NCBI ID
                                                </td>
                                                <td>
                                                    {{ item["UTA_Adapter"]["parsed_data"] }}
                                                </td>
                                            </tr>
                                            <tr><td>Position GRCh38</td><td>{{ item["variant_data"]["POS_hg38"] }}</td></tr>
                                            <tr><td>Position GRCh37</td><td>{{ item["variant_data"]["POS_hg19"] }}</td></tr>
                                            <tr><td>Reference/Alternate Base (+)</td><td>{{ item["dbnsfp"]["ref"] }} - {{ item["dbnsfp"]["alt"] }}</td></tr>

                                            <tr v-if="'UTA_Adapter_gene' in item"><td>Codon change</td><td>{{ item["UTA_Adapter_gene"]["nucleotide_change"] }}</td></tr>
                                            <tr><td>Codon position</td><td>{{ item["dbnsfp"]["codonpos"] }}</td></tr>
                                            <tr><td>Amino acid exchange</td><td>{{ item["UTA_Adapter"]["variant_exchange"] }}, {{ item["UTA_Adapter"]["variant_exchange_long"] }}</td></tr>
                                            <tr v-if="'dbnsfp' in item">
                                                <td>
                                                    Reference/Alternate amino acid
                                                </td>
                                                <td>
                                                    {{ this.aa_dc[item["dbnsfp"]["aaref"]] }} ({{ item["dbnsfp"]["aaref"] }})
                                                    - {{ this.aa_dc[item["dbnsfp"]["aaalt"]] }} ({{ item["dbnsfp"]["aaalt"] }})
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Transcript (MANE Select)
                                                </td>
                                                <td>
                                                    {{ item["UTA_Adapter_gene"]["c_dna_string"] }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Protein (RefSeq)
                                                </td>
                                                <td>
                                                    {{ item["UTA_Adapter"]["variant"] }}
                                                </td>
                                            </tr>
                                            <tr v-if="'gencode_genomic' in item">
                                                <td>
                                                    Protein (Ensembl)
                                                </td>
                                                <td>
                                                    {{ item["gencode_genomic"]["transcripts"][ item["gencode_genomic"]["MANE_Select_transcript"] ]["protein_id"] }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UniProt</td><td>{{ item["dbnsfp"]["Uniprot_acc"] }}</td>
                                            </tr>

                                         </v-table>
                                      </v-card>
                                  </div>
                        </v-col>
                        <v-col cols="12" md="12" lg="4" xl="4" justify="center" style="text-align:center;">

                                 <!-- dbSNP -->
                                 <div style="text-align:left;">
                                     <div class="content-box-toolbar-div">
                                            <v-toolbar class="rounded-lg elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                                 <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                       Allele Frequency
                                                 </v-toolbar-title>
                                            </v-toolbar>
                                     </div>
                                     <v-card class="elevation-1" style="padding-left:10px;padding-right:10px;">
                                        <div class="content-box-header-space"></div>
                                            <v-row>
                                                <v-card-subtitle style="padding-left:10px;">dbSNP</v-card-subtitle>
                                                <v-table style="text-align:left;padding:10px;" v-if="'dbsnp' in item">
                                                    <tr><td style="width:250px;">rsID</td><td>{{ item["dbsnp"]["rsID"] }}</td></tr>
                                                    <tr><td>Frequency(total)</td><td>{{ item["dbsnp"]["freq_total"] }}</td></tr>
                                                    <tr><td></td><td></td></tr>
                                                    <tr><td>Frequency(African)</td><td>{{ item["dbsnp"]["freq_african"] }}</td></tr>
                                                    <tr><td>Frequency(American)</td><td>{{ item["dbsnp"]["freq_americanAmerican"] }}</td></tr>
                                                    <tr><td>Frequency(Asian)</td><td>{{ item["dbsnp"]["freq_asian"] }}</td></tr>
                                                    <tr><td>Frequency(European)</td><td>{{ item["dbsnp"]["freq_european"] }}</td></tr>
                                                    <tr><td>Frequency(Latin American)</td><td>{{ item["dbsnp"]["freq_latinAmerican1"] }}</td></tr>
                                                    <tr><td>Frequency(Other)</td><td>{{ item["dbsnp"]["freq_other"] }}</td></tr>
                                                </v-table>
                                            </v-row>
                                            <v-row>
                                                <v-card-subtitle style="padding-left:10px;">ALFA</v-card-subtitle>
                                                <v-table style="text-align:left;padding:10px;" v-if="'dbnsfp' in item">
                                                    <tr><td style="width:250px;">Total allele frequency</td><td>{{ item["dbnsfp"]["ALFA_Total_AF"] }}</td></tr>
                                                    <tr><td>Total allele count</td><td>{{ item["dbnsfp"]["ALFA_Total_AC"] }}</td></tr>
                                                </v-table>
                                            </v-row>
                                            <v-row>
                                                <v-card-subtitle style="padding-left:10px;">gnomAD</v-card-subtitle>
                                                <v-table style="text-align:left;padding:10px;" v-if="'dbnsfp' in item">
                                                    <tr><td style="width:250px;">Exome allele frequency</td><td>{{ item["dbnsfp"]["gnomAD_genomes_AF"] }}</td></tr>
                                                    <tr><td>Exome allele count</td><td>{{ item["dbnsfp"]["gnomAD_genomes_AC"] }}</td></tr>
                                                </v-table>
                                            </v-row>
                                            <v-row v-if="'dbnsfp' in item">
                                                    <v-card-subtitle style="padding-left:10px;">ExAC</v-card-subtitle>
                                                    <v-table style="text-align:left;padding:10px;" v-if="'dbnsfp' in item">
                                                        <tr>
                                                            <td style="width:250px;">Allele frequency</td>
                                                            <td>{{ item["dbnsfp"]["ExAC_AF"] }}</td>
                                                        </tr>
                                                    </v-table>
                                            </v-row>
                                            <div style="height:10px;"></div>
                                        </v-card>
                                 </div>

                                 <!-- ClinVar -->
                                 <div v-if="'clinvar' in item" style="text-align:left;">
                                    <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-0" color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                             <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   ClinVar estimation
                                             </v-toolbar-title>
                                        </v-toolbar>
                                    </div>
                                    <v-card class="elevation-1 content-box" style="padding-left:10px;padding-right:10px;">
                                        <div class="content-box-header-space"></div>

                                        <!--<v-card-subtitle style="padding-left:10px;">ClinVar</v-card-subtitle>-->
                                        <v-table v-if="'clinvar' in item" style="text-align:left;padding:10px;">

                                            <tr v-if="'clinvar' in item">
                                                <td>Clinical Significance</td><td>{{ item["clinvar"]["CLNSIG"] }}</td>
                                            </tr>
                                            <tr v-if="'clinvar' in item">
                                                <td>Review status</td>
                                                <td>
                                                    <v-table>
                                                        <tr>
                                                            <td>
                                                                <v-rating v-model="item.clinvar.score" class="ma-2" density="compact" color="blue-grey-lighten-1" length="4">
                                                                </v-rating>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {{ item["clinvar"]["CLNREVSTAT"] }}
                                                            </td>
                                                        </tr>
                                                    </v-table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Conflicting clinical significance</td><td>{{ item["clinvar"]["conflicting_clinical_significance_label"] }}</td></tr>
                                            <tr><td>Variant Type</td><td>{{ item["clinvar"]["MC"] }}</td></tr>
                                            <tr><td>ClinVar ID</td><td>{{ item["clinvar"]["CLINVARID"] }}</td></tr>
                                            <tr><td>Allele ID</td><td>{{ item["clinvar"]["ALLELEID"] }}</td></tr>
                                            <tr><td>
                                                <a :href="'https://ncbi.nlm.nih.gov/clinvar/variation/'+ item['clinvar']['CLINVARID']">Show ClinVar entry </a>
                                            </td></tr>
                                        </v-table>
                                        <v-table v-else style="margin-top:10px; margin-bottom:10px;">
                                            <tr>
                                                <td>No ClinVar entry found</td>
                                            </tr>
                                        </v-table>
                                    </v-card>
                                 </div>
                        </v-col>
                        <v-col cols="12" md="12" lg="4" xl="4" align="left" justify="left" style="">


                                     <!-- Gene Descriptions -->
                                     <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                             <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Gene Information
                                             </v-toolbar-title>
                                        </v-toolbar>
                                     </div>
                                    <v-card class="content-box elevation-1" style="padding-left:10px;padding-right:10px;">
                                        <div style="height:25px;"></div>

                                        <span v-if="'oncokb' in item">
                                            <span v-if="'oncokb' in item['oncokb']">
                                                <span v-if="'geneSummary' in item['oncokb']['oncokb']">
                                                    <div>
                                                        <p v-if="'oncokb' in item" style="padding:10px;">
                                                            <span v-if="'oncokb' in item['oncokb']">
                                                                <span v-if="'geneSummary' in item['oncokb']['oncokb']">
                                                                    <text-clamp text="{{ item.oncokb.oncokb.exact_match.geneSummary }}" :max-lines='2' />
                                                                    <span style="color:#6f6f6f;">(Source: OncoKB)</span>
                                                                </span>
                                                            </span>
                                                        </p>
                                                        <p v-else>
                                                            No OncoKB gene entry found
                                                        </p>
                                                    </div>
                                                </span>
                                            </span>
                                        </span>

                                        <div v-if="'civic' in item" style="padding-top:5px;">
                                            <p v-if="'civic' in item['civic']" style="padding:10px;font-size:14px;">
                                                <span v-if="'gene_summary' in item['civic']['civic']">
                                                    <span v-if="'gene_summary' in item['civic']['civic']">
                                                        <div>
                                                            <span v-if="item['civic']['civic']['gene_summary'].length > 0">
                                                                <text-clamp :text="item.civic.civic.gene_summary[0].description" :max-lines='2' />
                                                                <span style="color:#6f6f6f;">(Source: CIViC)</span>
                                                            </span>
                                                        </div>
                                                        <div v-if="item['civic']['civic']['gene_summary'].length > 0" style="margin-top:4px;">
                                                                    <a style=""
                                                                        v-bind:href="item.civic.civic.gene_summary[0].gene_civic_url">
                                                                        Show CIViC gene entry ({{ item.civic.civic.gene_summary[0].name }})
                                                                    </a>
                                                        </div>
                                                    </span>
                                                </span>
                                            </p>
                                            <p v-else>
                                                No CIViC gene entry found
                                            </p>
                                        </div>
                                    </v-card>

                                    <!-- Variant Descriptions -->
                                    <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-0" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                             <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Variant Information
                                             </v-toolbar-title>
                                        </v-toolbar>
                                    </div>
                                    <v-card class="elevation-1 content-box" style="padding-left:20px;padding-right:20px;">
                                        <div style="height:30px;"></div>

                                            <div v-if="'civic' in item">
                                            <span v-if="'civic' in item.civic">
                                                <div v-if="'molecular_profile' in item.civic.civic">
                                                    <div v-if="'molecular_profile' in item['civic']['civic']">
                                                        <table>
                                                            <tr>
                                                                <td style="padding-right:20px;">CIViC Molecular Profile ID</td>
                                                                <td>{{ item.civic.civic.molecular_profile.molecular_profile_id }}</td>
                                                            </tr>
                                                        </table>
                                                        <p v-if="'molecular_profile' in item['civic']['civic']">
                                                            {{ item.civic.civic.molecular_profile.summary }}
                                                        </p>

                                                                <a style="font-size:12px;"
                                                                    v-bind:href="'https://civicdb.org/molecular-profiles/'+item.civic.civic.molecular_profile.molecular_profile_id">
                                                                    Show CIViC molecular profile ({{ item.civic.civic.molecular_profile.molecular_profile }})
                                                                </a>
                                                    </div>
                                                </div>
                                            </span>
                                            <span v-else>
                                                No CIViC molecular profile found
                                            </span>
                                            </div>

                                        <div style="padding-top:10px;">
                                            <p style="font-size:12px;">
                                                <span v-if="'oncokb' in item">
                                                    <span v-if="'oncokb' in item['oncokb']">
                                                         <span v-if="'exact_match' in item['oncokb']['oncokb']">
                                                             <span v-if="'mutationEffect' in item['oncokb']['oncokb']['exact_match']">
                                                                {{ item.oncokb.oncokb.exact_match.mutationEffect.description }}
                                                                <span style="color:#6f6f6f;">(Source: OncoKB)</span>
                                                             </span>
                                                         </span>
                                                    </span>
                                                </span>
                                            </p>
                                        </div>


                                    </v-card>



                        </v-col>

                   </v-row>
                </v-container>
            </span>
        </div>

         <div id="protein_plot">
         </div>

        <Loading v-model:active="isLoading" v-model="fullPage"
            :can-cancel="true"
            :is-full-page="fullPage" />

        <!--{{ this.$store.getters.getAppValue('revel') }}
        {{ this.$store.getters.getAppValue('loftool') }}
        {{ this.$store.getters.getAppValue('vuspredict') }}-->
        <!--{{ this.$store.getters.getVariants }}-->

    </div>
    <!--</v-container></div>-->

                        <div style="height:0px;">
                    </div>
                    <div style="padding:20px;">
                         <div id="igvContainer" ref="igvContainer">
                         </div>
                     </div>
                     <div style="height:0px;">
                     </div>
    </v-container>
</template>
<script>
import NavBar_Variant from '@/components/navbars/NavBar_Variant';
import variant_annotation from "@/methods/variant_annotation";
import active_variants from "@/methods/active_variants";
import axios from 'axios';
import igv_browser from "@/methods/igv_browser";
import useTooltip from '@/methods/tooltip.js';
//import AgGridCustom from '@/views/variant_views/AgGridCustom'

import { AgGridVue } from 'ag-grid-vue3';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

import { ref } from 'vue';

export default {
    name: "upload-data-variant-interpretation",
    data() {
        return {
            variantlisttext: '',
            flask_greeting: '',
            message: '',
            isLoading: false,
            fullPage: true,
            civic_summary: '',
            vcfContent: '',
            active_chrom : '',
            active_pos_start: 0,
            active_pos_end: 0,
            active_ref: '',
            active_alt: '',
            formatted_domain: '',
            aa_dc: {
                "A": "Alanine",
                "R": "Arginine",
                "N": "Asparagine",
                "D": "Aspartic acid",
                "C": "Cysteine",
                "E": "Glutamic acid",
                "Q": "Glutamine",
                "G": "Glycine",
                "H": "Histidine",
                "I": "Isoleucine",
                "L": "Leucine",
                "K": "Lysine",
                "M": "Methionine",
                "F": "Phenylalanine",
                "P": "Proline",
                "S": "Serine",
                "T": "Threonine",
                "W": "Tryptophan",
                "Y": "Tyrosine",
                "V": "Valine",
                "U": "Selenocysteine",
                "O": "Pyrrolysine"
            },
              columnDefs: [
                { field: "make", sortable: true, filter: true },
                { field: "model", sortable: true, filter: true },
                { field: "price", sortable: true, filter: true },
              ],
              rowData: [
                { make: "Toyota", model: "Celica", price: 35000 },
                { make: "Ford", model: "Mondeo", price: 32000 },
                { make: "Porsche", model: "Boxster", price: 72000 },
              ],
              defaultColDef: {
                resizable: true,
              },
              gridOptions: {
                rowSelection: "single", // Example grid option, you can add more
              },
              blosum_val: 0,
              blosum_color: '#ffffff',
        }
    },
    async mounted() {
        console.log("AgGridVue component:", AgGridVue);
          console.log("Column Definitions:", this.columnDefs);
  console.log("Row Data:", this.rowData);
    },
    created: async function() {
        this.$store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )
        await active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
        this.$store.dispatch('setProcessState', [  "load-results",'' ] )

        if (this.$store.getters.backRef == null) {
            this.$store.dispatch('setBackRef', '/upload')
        }

        //await this.initSeqviz()

        let activeBiomarker = this.$store.getters.getActiveBiomarker
        activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]

        // load GENCODE data
        if (!("gencode_genomic" in activeBiomarker)) {
            //alert("get gencode data")
            /*let genome_version = store.getters.getGenomeVersion
            let dataDir = "pub" //"loc"
            let url = store.getters.getPathVariable("methods_analyze_variants")
            await variant_annotation.analyzeUpdate(dataID, url,dataDir, "drug_classification", mode, genome_version,false, store.getters.requestID)*/
            var request_id = this.$store.getters.requestID
            await variant_annotation.analyzeVariants("gencode", "1", "pub", null, request_id = request_id)
            await active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
        } //else {alert(JSON.stringify(Object.keys(activeBiomarker)))}

        let chrom = activeBiomarker["variant_data"]["CHROM"]
        let pos = activeBiomarker["variant_data"]["POS"]
        let ref = activeBiomarker["variant_data"]["REF"]
        let alt = activeBiomarker["variant_data"]["ALT"]

        await this.loadData(chrom,pos,ref,alt)
        await igv_browser.initializeIGVBrowser(this.$refs.igvContainer,this.active_chrom,this.vcfContent)

        // Init AA viewer
        //this.loadProteinViewers()

        /*if ("variant_data" in activeBiomarker) {
            if ("blosum62" in activeBiomarker["variant_data"]) {
                this.blosum_val=this.getBlosumPercentage(activeBiomarker["variant_data"]["blosum62"])
                this.blosum_color=this.getBlosumColor(activeBiomarker["variant_data"]["blosum62"])
            }
        }*/

        this.formatted_domain = this.get_formatted_domain(activeBiomarker.dbnsfp.Interpro_domain)

    },
    computed: {
    },
    methods: {
        get_formatted_domain(val) {
            return val.split('|')[0];
        },
        onFirstDataRendered() {
          console.log("AG Grid is initialized and data is rendered.");
          console.log(this.columnDefs)
        },
        onGridReady(params) {
          this.gridOptions = params.api;
          this.gridOptions.sizeColumnsToFit();
        },
        showTooltip(element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        getRefAA(ref_aa) {
            let src = ""
            switch(ref_aa) {
                case 'A':
                    src = 'as_ala.gif'
                    break
                case 'R':
                    src = 'as_arg.gif'
                    break
                case 'N':
                    src = 'as_asn.gif'
                    break
                case 'D':
                    src = 'as_asp.gif'
                    break
                case 'C':
                    src = 'as_cys.gif'
                    break
                case 'E':
                    src = 'as_glu.gif'
                    break
                case 'Q':
                    src = 'as_gln.gif'
                    break
                case 'G':
                    src = 'as_gly.gif'
                    break
                case 'H':
                    src = 'as_his.gif'
                    break
                case 'I':
                    src = 'as_ile.gif'
                    break
                case 'L':
                    src = 'as_leu.gif'
                    break
                case 'K':
                    src = 'as_lys.gif'
                    break
                case 'M':
                    src = 'as_met.gif'
                    break
                case 'F':
                    src = 'as_phe.gif'
                    break
                case 'P':
                    src = 'as_pro.gif'
                    break
                case 'S':
                    src = 'as_ser.gif'
                    break
                case 'T':
                    src = 'as_thr.gif'
                    break
                case 'W':
                    src = 'as_trp.gif'
                    break
                case 'Y':
                    src = 'as_tyr.gif'
                    break
                case 'V':
                    src = 'as_val.gif'
                    break
                case 'U':
                    src = 'as_sec.gif'
                    break
                case 'O':
                    src = 'as_pyl.gif'
            }
            //alert(ref_aa + src)
            return require('./../../assets/amino_acids/'+src)
        },
        rerender_bars() {
            //this.revel_key += 1
            //this.loftool_key += 1
            //this.vuspredict_key += 1
            //this.mvp_key += 1
        },
        ltrim(x, characters) {
          var start = 0;
          while (characters.indexOf(x[start]) >= 0) {
            start += 1;
          }
          var end = x.length - 1;
          return x.substr(start);
        },
        rtrim(x, characters) {
          var start = 0;
          var end = x.length - 1;
          while (characters.indexOf(x[end]) >= 0) {
            end -= 1;
          }
          return x.substr(0, end + 1);
        },
        pos_formatted(pos_start) {
                    var splitString = String(pos_start).split("");

                    var reverseArray = splitString.reverse();
                    let reverseArraytoStr = ''
                    for (let i=0; i<reverseArray.length; i +=1) {
                        reverseArraytoStr += reverseArray[i]
                    }
                    //alert(reverseArraytoStr)
                    const result = reverseArraytoStr.match(/.{1,3}/g) || [];

                    let result_str = ''
                    for (let i=0; i<result.length; i +=1) {
                        result_str += result[i] + ','
                    }
                    result_str = this.rtrim(result_str,',')
                    //alert(result_str)

                    let result_arr = result_str.split("").reverse()
                    let result_splitted = ''
                    for (let i=0; i<result_arr.length; i +=1) {
                        result_splitted += result_arr[i]
                    }
                    result_splitted = this.ltrim(result_splitted,',')
                    return result_splitted
        },
        /**
        * Returns the content of the given file `path` as a string.
        *
        * @param {String} path
        *
        * @returns {String}
        */
        async content(chrom,pos,ref,alt) {
                let pos_start = parseInt(pos) -20
                let pos_end = parseInt(pos) + 20
                let cont = '##fileformat=VCFv4.1\nchr' + chrom + '\t' + pos + '\t.\t'+ ref +'\t' + alt + '\t.\t.\t.\n'

              let date = new Date(2023, 1, 1)
              this.vcfContent = new File([cont],'sample.vcf', {type: "text/plain", lastModified: date})

                    // pos_start
                    let result_start = this.pos_formatted(pos_start)
                    let result_end = this.pos_formatted(pos_end)
                    //alert(pos_start + ":" + result_start)
                    //alert(pos_end + ":" + result_end)

                this.active_chrom = 'chr' + chrom + ':' + result_start + "-" + result_end
                this.active_pos_start = pos_start
                this.active_pos_end = pos_end
                this.active_ref = ref
                this.active_alt = alt

        },
        async loadData(chrom,pos,ref,alt) {

            let path = ''
            this.content(chrom,pos,ref,alt)

            /*const igvBrowser = this.$refs.igvBrowser;
            igvBrowser.loadTrack({
                type: 'alignment',
                format: 'vcf',
                name: 'Data',
                url: file.fileData
            })*/
        },
        async initSeqviz() {
            //applyReactInVue(SeqViz)
            //this.Basic.render()

            /* seqviz("root", {
               name: "L09136",
               seq: "tcgcgcgtttcggtgatgacggtgaaaacctctgacacatgca",
               style: { height: "100vh", width: "100vw" },
             })
             .render();*/

            /*const element = document.getElementById("seqvizcontent");
            const props = { name:"test", seq:"tcgcgcgtttcggtgatgacggtgaaaacctctgacacatgca",style: { height: "100vh", width: "100vw" } }
            const viewer = seqviz.Viewer(element, props);
            // Render the viewer to the DOM at the node passed in $element`.
            viewer.render();
            // To later update the viewer's configuration and re-renders.
            viewer.setState(props);
            // To render the viewer, eg for server-side rendering, and returns it as an HTML string.
            viewer.renderToString();*/
        },
        async loadProteinViewers() {
            let activeBiomarker = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]


            let sdfData = `
            ALA
  -OEChem-07192416193D

 13 12  0     1  0  0  0  0  0999 V2000
   -0.9660    0.4930    1.5000 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.2570    0.4180    0.6920 C   0  0  2  0  0  0  0  0  0  0  0  0
   -0.0940    0.0170   -0.7160 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0560   -0.6820   -0.9230 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.2040   -0.6200    1.2960 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6610    0.4390   -1.7420 O   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3830   -0.4250    1.4820 H   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6760    0.6610    2.4520 H   0  0  0  0  0  0  0  0  0  0  0  0
    0.7460    1.3920    0.6820 H   0  0  0  0  0  0  0  0  0  0  0  0
    1.4590   -0.3300    2.3160 H   0  0  0  0  0  0  0  0  0  0  0  0
    0.7150   -1.5940    1.3070 H   0  0  0  0  0  0  0  0  0  0  0  0
    2.1130   -0.6760    0.6970 H   0  0  0  0  0  0  0  0  0  0  0  0
    0.4350    0.1820   -2.6470 H   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  1  7  1  0  0  0  0
  1  8  1  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  2  9  1  0  0  0  0
  3  4  2  0  0  0  0
  3  6  1  0  0  0  0
  5 10  1  0  0  0  0
  5 11  1  0  0  0  0
  5 12  1  0  0  0  0
  6 13  1  0  0  0  0
M  END
> <OPENEYE_ISO_SMILES>
C[C@@H](C(=O)O)N

> <OPENEYE_INCHI>
InChI=1S/C3H7NO2/c1-2(4)3(5)6/h2H,4H2,1H3,(H,5,6)/t2-/m0/s1

> <OPENEYE_INCHIKEY>
QNAYBMKLOCPYGJ-REOHCLBHSA-N

> <FORMULA>
C3H7NO2

$$$$

        `

            let refid = activeBiomarker["UTA_Adapter_gene"]["ref"]
            if (refid!=undefined) {
                //alert(refid)
                //alert(this.$refs.aarefviewer)
                try {
                    const div = document.getElementById('aarefviewer');
                    if (div) {
                        // Proceed with 3DMolJS viewer creation
                        //alert("element found")
                    } else {
                        console.error('Element not found');
                        //alert("no element")
                    }

                    var aaviewer = $3Dmol.createViewer(this.$refs.aarefviewer);
                    //var molecule = aaviewer.addModel(sdfData, "sdf");
                    //var molecule = aaviewer.addModel(pdb_data, "pdb");
                } catch(e) {
                    console.log(e)
                    //alert(e)
                }
            }

        },
        async renderSDF(sdfData) {
          if (this.viewer) {
            this.viewer.clear();
          } else {
            this.viewer = $3Dmol.createViewer(this.$refs.aarefviewer, {
              defaultcolors: $3Dmol.rasmolElementColors
            });
          }

          this.viewer.addModel(sdfData, "sdf");
          this.viewer.setStyle({}, { stick: { radius: 0.2 }, sphere: { radius: 0.4 } });
          this.viewer.zoomTo();
          this.viewer.render();
        }
    },
    components: {
        NavBar_Variant
    }
}

</script>
<style>
.bground-main {
    background-color: #ffffff;
}
.content-box {
    margin-left:0px;
    text-align: left;
    padding:20px;
}
.content-box-title {
}
.content-box-header-space {
  height:0px;
}
.content-box-toolbar-div {
  margin:auto;width:90%;position:relative; top:20px;z-index:10;
  margin-bottom:0;
  margin-top:0;
}
.flip_bar {
-moz-transform: scale(-1, 1);
-webkit-transform: scale(-1, 1);
-o-transform: scale(-1, 1);
-ms-transform: scale(-1, 1);
transform: scale(-1, 1);
}
.content-background {
background-color: #f0f2f5;
}
#progress-bar-container {
	width: 100px;
	height: 60px;
	margin: 0 auto;
	/*position: relative;*/
	/*top: 50%;*/
	/*transform: translateY(-50%);*/
	/*border-radius: 35px;*/
	overflow: hidden;
	/*rotate: 180deg;*/
}

.progress-bar-child {
	width: 100%;
	height: 100%;
}

.progress {
	color: white;
	text-align: center;
	line-height: 75px;
	font-size: 35px;
	font-family: "Segoe UI";
	animation-direction: reverse;
	background: #e5405e;

	/* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to right, #e5405e 0%, #ffdb3a 45%, #3fffa2 100%);
}

@import '~ag-grid-community/styles/ag-grid.css';
@import '~ag-grid-community/styles/ag-theme-alpine.css';
</style>
